export function resolveConfiguration(catalog, options, extras = {}, quantity = 1) {
  const variant = catalog.variants.find(v => v.options.every((value, i) => value === options[i]));
  const pipes = catalog.pipes.find(v => v.options[0] === options[2] && v.options[1] === options[0]);
  const wheels = catalog.wheels.find(v => v.available) || catalog.wheels[0];
  const errors = [];
  if (!variant?.available) errors.push('unavailable');
  if (!Number.isSafeInteger(quantity) || quantity < 1) errors.push('quantity_error');
  if (extras.pipes && !pipes?.available) errors.push('pipes_unavailable');
  if (extras.wheels && !wheels?.available) errors.push('wheels_unavailable');
  const chosen = [variant, extras.pipes ? pipes : null, extras.wheels ? wheels : null].filter(Boolean);
  const unitPrice = chosen.reduce((total, item) => total + item.price, 0);
  return {
    variant, pipes, wheels, errors, unitPrice,
    total: errors.length ? null : unitPrice * quantity,
    items: errors.length ? [] : chosen.map(item => ({ id: item.id, quantity }))
  };
}
